// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3Y1uK","addWidgetButton":"Header_addWidgetButton__3wEid","dashboardTabs":"Header_dashboardTabs__3b08B","active":"Header_active__371tz"};